import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-device-list-empty',
    templateUrl: './device-list-empty.component.html',
    styleUrls: ['./device-list-empty.component.css'],
    standalone: true,
    imports: [TranslateModule, FormsModule]
})
export class DeviceListEmptyComponent implements OnInit {

  @Input() tracker: any;

  showEmptyPage: boolean = false;

  ngOnInit(): void {
    if(this.tracker.length === 0){
      this.showEmptyPage = true;
    }else{
      this.showEmptyPage = false;
    }
  }

}
